<template>
  <div class="outline">
    <div class="leftRow">
      <div class="body">
        <img src="@/assets/image/logo.png" class="middleImg" />
         <div style="margin:4.444vh 0px 0px 3.0208vw;height:9.259vh">
          <div style="float:left">
            <div class="english">HOTEL</div>
          </div>
          <div class="chinese">住宿</div>
        </div>
        <div class="footerMenu" style="margin-left:1.71875vw">
          <div
            :class="classNameB"
            @mouseover="classNameB = 'colAHover'"
            @mouseout="classNameB = 'colA'"
            @click="openTypeLise(2)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">经</div>
            <div class="chaFont">济</div>
            <div class="chaFont">酒</div>
            <div class="chaFont">店</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
          <div
            :class="classNameC"
            @mouseover="classNameC = 'colAHover'"
            @mouseout="classNameC = 'colA'"
            @click="openTypeLise(1)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">星</div>
            <div class="chaFont">级</div>
            <div class="chaFont">酒</div>
            <div class="chaFont">店</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import  "@/css/switch.css"
import Banner from "../../components/common/banner";
export default {
  name: "OutLine",
  components: { Banner },
  data() {
    return {
      classNameA: "colA",
      classNameB: "colA",
      classNameC: "colA",
      classNameD: "colA"
    };
  },
  methods: {
    openTypeLise(type) {
      this.$store.commit("setChildMenu",5);
      this.$store.commit("setTabPage", type);
      this.$store.commit("setShowSwitchMenu", false);
      let name = "TabHotel";
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/hotel/hotelSwitch.vue